import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import 'react-app-polyfill/stable';

import App from './containers/app';
import BitsyApollo from './services/BitsyApollo';

const BitsyCustomerFrontendApp = (
  <ApolloProvider client={BitsyApollo.client}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ApolloProvider>
);

const container = document.getElementById('root');
const root = createRoot(container);
root.render(BitsyCustomerFrontendApp);
